export const TYPE_FREE = "FREE";
export const TYPE_UPDATE = "UPDATE";

export const TRANSLATIONS = {
  EDITING_MENU_BTN: "目的更新",
  EDITING_DETAIL_BTN: "トレーニングメニュー更新",
  TITLE: "トレーニングメニュー詳細",
  LABEL_ID: "会員ID",
};
